import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(private http: HttpClient) { }

  //Behavior Subject for Category
  private category = new BehaviorSubject('');

  getCategory(): Observable<any> {
    return this.category.asObservable();
  }

  setCategory(cat) {
    this.category.next(cat);
  }

   //Behavior Subject for Bin
   private bin = new BehaviorSubject('');

   getBin(): Observable<any> {
     return this.bin.asObservable();
   }

   setBin(bin) {
     this.bin.next(bin);
   }

  getAllGroups(parentGroupId?) {
    let params = new HttpParams();
        params =  (parentGroupId ?params.append('parentGroupId', parentGroupId):params)
    return this.http.get<any>(`${environment.inventoryURl}Group`,{params:params});
  }

  getAttnContactLost(search) {
    const searchData = encodeURIComponent(search);
    return this.http.get<any>(
        `${environment.appOrgUrl}User/UsersWithName?search=${searchData}`
    );
  }

  addLocationGroup(data) {
    return this.http.post<any>(`${environment.coreUrl}Group`, data)
      .toPromise()
      .then(res => res);
  }

  getAllGroupTypes(groupId) {
    return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${groupId}`);
  }

  getAllCategory(groupId) {
    return this.http.get<any>(`${environment.inventoryURl}Category?groupId=${groupId}`);
  }

  getAddressTypes() {
    return this.http.get<any>(`${environment.coreUrl}Address/AddressType`);
  }


  getCountry() {
    return this.http.get<any>(`${environment.coreUrl}Country`);
  }

  getAllStates(countryId: number) {
    return this.http.get<any>(`${environment.coreUrl}State`, {
        params: new HttpParams().append("countryId", countryId.toString())
    })
        .toPromise()
        .then(res => res);
}

  getAllCities(stateId) {
    return this.http.get<any>(`${environment.coreUrl}City`, {
      params: new HttpParams().append("stateId", stateId.toString())
  })
      .toPromise()
      .then(res => res);
  }

  getLocationList() {
    let params = new HttpParams();
        params =  params.append('PageNumber', '0')
        params =  params.append('PageSize', '0')
        params = params.append('isascending', 'false')
        params = params.append('sortby', 'locationid')
    return this.http.get<any>(`${environment.inventoryURl}Warehouse`,{params: params});
  }

  getWarehouseStatus(id): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}Warehouse/CheckWarehouseProductExist?warehouseId=${id}`);
  }

  getWarehouseQBStatus(id): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}Warehouse/CheckWarehouseQBExist?warehouseId=${id}`);
  }

  deleteLocation(id) {
    return this.http.delete<any>(`${environment.inventoryURl}Warehouse/${id}`)
      .toPromise()
      .then(res => res);
  }

  addLocation(data) {
    return this.http.post<any>(`${environment.inventoryURl}Warehouse`, data)
      .toPromise()
      .then(res => res);
  }

  updateLocation(data) {
    return this.http.put<any>(`${environment.inventoryURl}Warehouse`, data)
      .toPromise()
  }

  updateDefaultLocation(id) {
    return this.http.get<any>(`${environment.inventoryURl}Warehouse/SetDefault?warehouseId=${id}`)
  }

  addState(data: object) {
    return this.http.post<any>(`${environment.coreUrl}State`, data)
    .toPromise()
    .then(res => res);
  }

  addCity(data: object) {
    return this.http.post<any>(`${environment.coreUrl}City`, data)
    .toPromise()
    .then(res => res);
  }

  checkIsDuplicateLocation(locationId,warehouseId) {
    let params = new HttpParams();
    params =  params.append('locationId', locationId)
    params =  params.append('warehouseId', warehouseId)
    return this.http.get<any>(`${environment.inventoryURl}Warehouse/CheckIsDuplicateLocationId`, {params});
  }

}
